import { cn } from '@/lib/utils';

export interface SparkleProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Sets both width and height
   */
  size?: number;
  /**
   * Outline stroke width
   */
  strokeWidth?: number;
}

export function Sparkle({ size = 20, strokeWidth = 1.5, className, ...props }: SparkleProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('inline-block flex-shrink-0', className)}
      aria-hidden="true"
      {...props}
    >
      <path d="M12 3.5 14.05 8.95 19.5 11 14.05 13.05 12 18.5 9.95 13.05 4.5 11 9.95 8.95 12 3.5Z" />
      <path d="M18.5 4.25 19.1 5.6 20.5 6.2 19.1 6.8 18.5 8.15 17.9 6.8 16.5 6.2 17.9 5.6 18.5 4.25Z" />
      <path d="M18 15.85 18.45 16.9 19.55 17.35 18.45 17.8 18 18.85 17.55 17.8 16.45 17.35 17.55 16.9 18 15.85Z" />
    </svg>
  );
}
